/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var JewelCrownIcon24Solid = forwardRef('JewelCrownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.63 3.297A.796.796 0 0 0 12 3a.796.796 0 0 0-.63.297L7.973 7.69l-4.75-3.135a.836.836 0 0 0-.849-.035.677.677 0 0 0-.367.693l1.375 8.984C3.54 15.231 4.516 16 5.668 16h12.637c1.15 0 2.124-.766 2.285-1.797l1.402-8.988a.676.676 0 0 0-.365-.694.836.836 0 0 0-.85.034l-4.75 3.135-3.397-4.393Z" }),
        React.createElement("path", { d: "M5 18a1.5 1.5 0 0 0 0 3h14a1.5 1.5 0 0 0 0-3H5Z" })));
});
